const status = {
  Pending: "",
  SubmittedByInitiator: "",
  RejectedByReviewer: "",
  DraftByIR: "IR",
  SendToIPFromSupervisor: "",
  SendToIRFromSupervisor: "IR",
  SendToIP: "IP",
  SendForReview: "",
  SubmittedByVendor: "",
  SendToIRFromIP: "IR",
  SendToIRFromLogistics: "IR",
  SendToDeptFromLoamApprover: "Department Coordinator",
  SendToIRFromDeptCoord: "IR",
  SendToImportFromIP: "",
  SubmittedByDept: "Department Coordinator",
  SendToTax: "TaxTeam",
  SendToBuyer: "",
  SendToInitiatorFromIR: "",
  SendToDeptCoordinator: "Department Coordinator",
  SendToLogistics: "",
  Reject: "",
  RejectedByTaxCheck: "TaxTeam",
  SendToLoamApprover: "Loam Approver",
  SendToSupervisor: "APS",
  SendToAPS: "APS",
  SendToReviewer: "",
  Completed: "",
  SendToDeptFromReviewer: "Department Coordinator",
  SendToDeptFromIP: "Department Coordinator",
  SendToIR: "IR",
  SendToIRFromBuyer: "IR",
  SendToTaxTeam: "TaxTeam",
  SendToIRFromTax: "IR",
  DraftByInitiator: "DraftByInitiator",
};

const initiatorStatus = {
  SendToInitiatorFromDeptCoordinator:true,
  SendToInitiatorFromIR: true,
  DraftByInitiator: true,
  SendToIR: false,
  SendToIRFromIP: false,
  SendToIRFromTaxTeam: false,
  SendToIRFromSupervisor: false,
  SendToIRFromLogistics: false,
  SendToIRFromDeptCoordinator: false,
  SendToIRFromLoamApprover: false,
  SendToTaxTeam: false,
  SendToTaxTeamFromIP: false,
  SendToTaxTeamFromDeptCoordinator: false,
  SendToTaxTeamFromLoamApprover: false,
  SendToIP: false,
  SendToIPFromSupervisor: false,
  SendToDeptCoordinator: false,
  SendToDeptCoordinatorFromLoamApprover: false,
  SendToDeptCoordinatorFromReviewer: false,
  SendToLoamApprover: false,
  SendToReviewer: false,
  SendToDeptCoordinatorFromIP:false,
  SendToDeptCoordinatorFromLoamApprover:false,
  SendToDeptCoordinator: false,
  SendToLoamApprover: false,
  SendToIP: false,
  SendToReviewer: false,
  Completed: false,
  PAID:false,
  SendToIRFromDeptCoordinator: false,
  SendToIRFromLoamApprover: false,
  SendToIRFromIP: false,
  SendToTaxTeamFromIP: false,
  SendToTaxTeamFromDeptCoordinator: false,
  SendToTaxTeamFromLoamApprover: false,
};

const irStatus = {
  SendToDeptCoordinatorFromIP:false,
  SendToIRFromReviewer:true,
  SendToReviewerFromIR:false,
  SendToIR: true,
  DraftByIR: true,
  SubmittedByVendor: true,
  SendToInitiatorFromIR: false,
  SendToTaxTeam: false,
  SendToIP: false,
  SendToSupervisor: false,
  SendToLogistics: false,
  SendToReviewer: false,
  SendToDeptCoordinator: false,
  SendToTaxTeamFromIP: false,
  SendToVendorFromIR: false,
  Reject: false,
  SendToIRFromBuyer: true,
  SendToIRFromPRInitiator: true,
  SendToIRFromIP: true,
  SendToIRFromTaxTeam: true,
  SendToIRFromSupervisor: true,
  SendToIRFromLogistics: true,
  SendToIRFromDeptCoordinator: true,
  SendToIRFromLoamApprover: true,
  Completed: false,
  Pending: true,
  SendToLoamApprover: false,
  SendToSupervisorFromManager: false,
  SendToBuyer: false,
  SendToPRInitiator: false,
  PAID:false,
};

const ipStatus = {
  SendToReviewerFromIP:false,
  SendToIP: true,
  SendToIRFromIP: false,
  SendToTaxTeamFromIP: false,
  SendToManager: false,
  SendToIPFromSupervisor: true,
  SendToSupervisor: false,
  Completed: false,
  PAID:false,
};

const taxTeamStatus = {
  SendToIP: false,
  SendToDeptCoordinator: false,
  SendToTaxTeamFromIP: true,
  SendToLoamApprover: false,
  SendToSupervisor: false,
  SendToTaxTeam: true,
  SendToIRFromTaxTeam: false,
  SendToIPFromSupervisor: false,
  SendToIRFromSupervisor: false,
  SendToGM: false,
  Completed: false,
  PAID:false,
};
const reviewerStatus = {
  SendToInitiatorFromIR: false,
  SendToReviewer2FromLoamApprover:true,
  SendToReviewerFromLoamApprover : true ,
  SendToReviewerFromIP:true,
  SendToReviewerFromIR:true,
  SendToIRFromReviewer:false,
  SendToReviewer: true,
  SendToReviewer2: true,
  SendToReviewer2FromDeptCoordinator: true,
  SendToReviewerFromSupervisor: true,
  SendToReviewerFromManager: true,
  SendToReviewerFromGM: true,
  SendToReviewerFromReviewer2: true,
  SendToReviewer: true,
  SendToLoamApproverFromReviewer: false,
  SendToReviewer2FromDeptCoordinator: true,
  SendToReviewerFromReviewer2: true,
  SendToLoamApprover: false,
  SendToIP: false,
  SendToLoamApproverFromReviewer: false,
  SendToSupervisor: false,
  Completed: false,
  PAID:false,
  SendToReviewerFromReviewer2: true,
  SendToDeptCoordinatorFromReviewer: false,
  SendToEfdvInitiatorFromReviewer: false,
  SendToDeptCoordinator: false,
};

const depCoordinatorStatus = {
  SendToDeptCoordinatorFromLoamApprover: true,
  SendToIRFromDeptCoord: false,
  SubmittedByDept: false,
  SendToDeptCoordinator: true,
  SendToDeptFromReviewer: true,
  SendToDeptFromIP: true,
  SendToIP: false,
  SendToSupervisor: false,
  SendToDeptCoordinatorFromReviewer: true,
  SendToReviewer: false,
  SendToTaxTeam: false,
  SendToLoamApprover: false,
  SendToIRFromDeptCoordinator: false,
  SendToDeptCoordinatorFromIP: true,
  SendToInitiatorFromIR:false,
  Completed	:false,
  PAID:false,
  SendToIR:false,
  SendToIPFromSupervisor:false,
};

const loamStatus = {
  SendToReviewer2FromLoamApprover:false,
  SendToReviewerFromLoamApprover : false ,
  SendToLoamApproverFromReviewer: true,
  SendToLoamApprover: true,
  SendToIP: false,
  Completed: false,
  PAID:false,
  SendToReviewer: false,
  SendToIRFromLoamApprover: false,
  SendToImportFromLoamApprover: false,
  SendToDeptFromLoamApprover: false,
  SendToTaxTeamFromLoamApprover: false,
  SendToDeptCoordinatorFromLoamApprover: false,
};

const importStatus = {
  DraftByImport: true,
  SendToImportFromLoamApprover: true,
  SendToImportFromReviewer: true,
  SendToImportFromIP: true,
  SendToLoamApprover: false,
  SendToIP: false,
  Completed: false,
  SendToReviewer:false,
  SendToImportFromSupervisor : true
};

const aps_Status = {
  SendToSupervisor: true,
  SendToIRFromSupervisor: false,
  SendToIPFromSupervisor: false,
  SendToReviewerFromSupervisor: false,
  Completed: false,
  SendToManager: false,
  SendToGM: false,
  SendToSupervisorFromManager: true,
  SendToSupervisorFromGM: true,
  SendToSupervisorFromDirector: true,
  PAID:false,
  SendToEfdvInitiatorFromSupervisor: false ,
   SendToImportFromSupervisor : false
};
const manager_Status = {
  SendToIRFromManager: false,
  SendToSupervisorFromManager: false,
  SendToIPFromManager: false,
  SendToManager: true,
  SendToSupervisor: false,
  SendToGM: false,
  SendToIRFromSupervisor: false,
  SendToIPFromSupervisor: false,
  SendToReviewerFromSupervisor: false,
  SendToReviewerFromManager: false,
  Completed: false,
  PAID:false,

};
const gm_Status = {
  SendToIRFromGM: false,
  SendToSupervisorFromGM: false,
  SendToIPFromGM: false,
  SendToGM: true,
  SendToReviewerFromGM: false,
  Completed: false,
  PAID:false,

};

const logisticStatus = {
  SendToLogistics: true,
  SendToIRFromLogistics: false,
  SendToIP: false,
  SendToTaxTeam: false,
  Completed: false,
  PAID:false,

};
const buyerStatus = {
  SendToBuyer: true,
  SendToIRFromBuyer: false,
};
const PrInitiatorStatus = {
  SendToPRInitiator: true,
  SendToIRFromPRInitiator: false,
};
const efdv_Status = {
  SendToReviewer2FromLoamApprover:false,
  SendToReviewerFromLoamApprover : false ,
  SendToReviewerFromReviewer2: false,
  SendToEfdvInitiatorFromReviewer: true,
  DraftByEFDVInitiator: true,
  SendToReviewer: false,
  SendToReviewer2: false,
  SendToLoamApprover: false,
  SendToEfdvInitiatorFromIP: true,
  SendToEfdvInitiatorFromDeptCoordinator: true ,
  SendToIP: false,
  Completed: false,
  PAID:false,
  SendToEfdvInitiatorFromSupervisor: true ,
};
const hrstatus = {
  DraftByHr: true,
  SendToIP: false,
  SendToHrFromLineManager: true,
  SendToHrFromSharedServices: true,
  SendToHrFromDirectorHR: true,
  SendToHRFromIP: true,
  SendToHrFromIP: true,
  SendToLineManager: false,
  SendToLineManagerFromSharedServices: false,
  SendToLineManagerFromIP: false,
  SendToSharedServices: false,
  SendToSharedServicesFromDirectorHR: false,
  SendToDirectorHR: false,
  SendToDirectorHRFromIP: false,
  PAID:false,
  Completed: false,
};
const lineManagerStatus = {
  SendToIP: false,
  SendToHrFromLineManager: false,
  SendToLineManagerFromIP: true,
  SendToLineManager: true,
  SendToLineManagerFromSharedServices: true,
  SendToSharedServices: false,
  SendToSharedServicesFromDirectorHR: false,
  SendToDirectorHR: false,
  SendToDirectorHRFromIP: false,
};
const sharedservices = {
  SendToIP: false,
  SendToHrFromLineManager: false,
  SendToLineManager: false,
  SendToLineManagerFromSharedServices: false,
  SendToSharedServices: true,
  SendToSharedServicesFromDirectorHR: true,
  SendToDirectorHR: false,
  SendToDirectorHRFromIP: false,
};
const directorHR = {
  SendToIP: false,
  SendToHrFromLineManager: false,
  SendToLineManager: false,
  SendToLineManagerFromSharedServices: false,
  SendToSharedServices: false,
  SendToSharedServicesFromDirectorHR: false,
  SendToDirectorHR: true,
  SendToDirectorHRFromIP: true,
};
const viewOnlyStatus = {
  Completed: true,
  PAID:true,
  Reject:true,
  Deleted:true,
  SendToSupervisor:true

}
const roles = [
  { role: "I2P Initiator", code: "1" },
  { role: "IR", code: "2" },
  { role: "Import", code: "3" },
  { role: "Logistic", code: "4" },
  { role: "EFDV Initiator", code: "5" },
  { role: "HR", code: "6" },
];

const demandType = [
  { role: "Deposit", code: "1" },
  { role: "Spare Parts", code: "2" },
  { role: "Material", code: "3" },
  { role: "Samples", code: "4" },
];
const category = [
  { role: "Employee Advance", code: "1" },
  { role: "Employee Loan", code: "2" },
  { role: "Payroll Related Payments", code: "3" },
  { role: "EOBI Payments", code: "4" },
  { role: "Others", code: "5" },
  { role: "Final Settlement – Normal", code: "6" },
  { role: "Final Settlement – Death case", code: "7" },
];
const invoiceType = [
  { role: "Material", code: "1" },
  { role: " Spare Parts", code: "2" },
  { role: "Samples", code: "3" },
];

export {
  status,
  initiatorStatus,
  irStatus,
  ipStatus,
  taxTeamStatus,
  depCoordinatorStatus,
  reviewerStatus,
  loamStatus,
  importStatus,
  aps_Status,
  manager_Status,
  gm_Status,
  logisticStatus,
  roles,
  demandType,
  category,
  invoiceType,
  buyerStatus,
  efdv_Status,
  hrstatus,
  lineManagerStatus,
  sharedservices,
  directorHR,
  PrInitiatorStatus,
  viewOnlyStatus
};